import { Box } from "@chakra-ui/react";
import { ReactNode } from "react";

interface ShadowBoxProps {
  rounded?: number;
  bg?: string | object;
  children?: ReactNode;
  color?: string | object;
  border?: string | object;
  p?: string | object | number;
  w?: string | object | number;
  borderColor?: string | object;
  mt?: string | object | number;
  mb?: string | object | number;
  my?: string | object | number;
  mx?: string | object | number;
  ml?: string | object | number;
  mr?: string | object | number;
  props?: any;
}

const ShadowBox = ({
  w,
  p,
  bg,
  mt,
  mb,
  my,
  mx,
  ml,
  mr,
  color,
  border,
  rounded,
  children,
  borderColor,
  props,
}: ShadowBoxProps) => {
  return (
    <Box
      w={w}
      p={p}
      mt={mt}
      mb={mb}
      my={my}
      mx={mx}
      mr={mr}
      ml={ml}
      bg={bg}
      color={color}
      border={border}
      rounded={rounded}
      borderColor={borderColor}
      boxShadow="rgb(0 0 0 / 20%) 0px 0px 11px"
      {...props}
    >
      {children}
    </Box>
  );
};

export default ShadowBox;

ShadowBox.defaultProps = {
  bg: "white",
  rounded: "8",
  p: { base: "1rem", md: "1.125rem 1.375rem" },
};
